import React from 'react';

export const DashboardNav = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.16667 12.5V15.8333H7.5V12.5H4.16667ZM3.33333 10.8333C2.8731 10.8333 2.5 11.2064 2.5 11.6667V16.6667C2.5 17.1269 2.8731 17.5 3.33333 17.5H8.33333C8.79357 17.5 9.16667 17.1269 9.16667 16.6667V11.6667C9.16667 11.2064 8.79357 10.8333 8.33333 10.8333H3.33333Z"
      fill="#6E6B8C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.16667 4.16662V7.49995H7.5V4.16662H4.16667ZM3.33333 2.49995C2.8731 2.49995 2.5 2.87305 2.5 3.33329V8.33329C2.5 8.79352 2.8731 9.16662 3.33333 9.16662H8.33333C8.79357 9.16662 9.16667 8.79352 9.16667 8.33329V3.33329C9.16667 2.87305 8.79357 2.49995 8.33333 2.49995H3.33333Z"
      fill="#6E6B8C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4999 12.5V15.8333H15.8333V12.5H12.4999ZM11.6666 10.8333C11.2063 10.8333 10.8333 11.2064 10.8333 11.6667V16.6667C10.8333 17.1269 11.2063 17.5 11.6666 17.5H16.6666C17.1268 17.5 17.4999 17.1269 17.4999 16.6667V11.6667C17.4999 11.2064 17.1268 10.8333 16.6666 10.8333H11.6666Z"
      fill="#6E6B8C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1667 4.02362L12.399 5.79139L14.1667 7.55915L15.9345 5.79139L14.1667 4.02362ZM14.756 2.25585C14.4306 1.93041 13.9029 1.93041 13.5775 2.25585L10.6312 5.20213C10.3058 5.52757 10.3058 6.0552 10.6312 6.38064L13.5775 9.32692C13.9029 9.65236 14.4306 9.65236 14.756 9.32692L17.7023 6.38064C18.0277 6.0552 18.0277 5.52757 17.7023 5.20213L14.756 2.25585Z"
      fill="#6E6B8C"
    />
  </svg>
);
